<app-page-header
    icon="badge"
    title="Modificar Afiliado"
    subtitle="Datos del afiliado, grupo familiar y gestión"
></app-page-header>

<app-loading *ngIf="!flagLoaded" class="m-5"></app-loading>

<div class="afiliado-form-area seguridad-animate-in" *ngIf="flagLoaded">
    <div class="container">
        <!-- ================= Cabecera del afiliado ================= -->
        <div class="ds-card afiliado-head">
            <div class="ds-accent"></div>
            <div class="afiliado-head__body">
                <div class="afiliado-head__id">
                    <span class="material-icons afiliado-head__icon">account_circle</span>
                    <div>
                        <h2 class="afiliado-head__nombre">
                            {{ usuario?.nombrePersona }} {{ usuario?.apellidoPersona }}
                        </h2>
                        <p class="afiliado-head__meta">
                            <span *ngIf="usuario?.identificacion">DNI {{ usuario?.identificacion }}</span>
                            <span *ngIf="usuario?.email"> · {{ usuario?.email }}</span>
                        </p>
                    </div>
                </div>

                <div class="afiliado-head__actions">
                    <button
                        type="button"
                        class="ds-pill ds-pill--outline"
                        (click)="mostrarDatosGecros()"
                        [matTooltip]="
                            mostrarCard
                                ? 'Ocultar los datos que devuelve Gecros'
                                : 'Ver los datos que devuelve Gecros para este afiliado'
                        "
                    >
                        <span class="material-icons">{{ mostrarCard ? 'visibility_off' : 'visibility' }}</span>
                        {{ mostrarCard ? 'Ocultar' : 'Mostrar' }} datos Gecros
                    </button>
                </div>
            </div>
            <mat-progress-bar *ngIf="flagProcesando" mode="indeterminate"></mat-progress-bar>
        </div>

        <!-- ================= Datos Gecros ================= -->
        <div class="ds-card afiliado-gecros" *ngIf="mostrarCard">
            <div class="ds-section__head">
                <span class="material-icons">sync_alt</span>
                Datos Gecros
            </div>
            <div class="ds-section__body">
                <div class="ds-summary ds-summary--grid">
                    <div class="ds-summary__row" *ngFor="let campo of gecrosResumen">
                        <span class="ds-summary__key">{{ campo.label }}</span>
                        <span class="ds-summary__value">{{ campo.value || '—' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- ================= Pestañas ================= -->
        <div class="ds-tabbar afiliado-tabs">
            <button
                type="button"
                class="ds-tab"
                [class.ds-tab--active]="tabActiva === 'informacion'"
                (click)="cambiarTab('informacion')"
            >
                Información Básica
            </button>
            <button
                type="button"
                class="ds-tab"
                [class.ds-tab--active]="tabActiva === 'grupo-familiar'"
                (click)="cambiarTab('grupo-familiar')"
            >
                Grupo Familiar
            </button>
            <button
                type="button"
                class="ds-tab"
                [class.ds-tab--active]="tabActiva === 'gestion'"
                (click)="cambiarTab('gestion')"
            >
                Gestión
            </button>
            <button
                type="button"
                class="ds-tab"
                [class.ds-tab--active]="tabActiva === 'tramites'"
                (click)="cambiarTab('tramites')"
            >
                Trámites
            </button>
        </div>

        <!-- ================= Información básica ================= -->
        <div class="afiliado-pane" *ngIf="tabActiva === 'informacion'">
            <form [formGroup]="formAfiliado" (ngSubmit)="onSubmit()">
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">person</span>
                        Datos personales
                    </div>
                    <div class="ds-section__body">
                        <div class="afiliado-grid">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Nombre</mat-label>
                                <input
                                    matInput
                                    formControlName="nombre"
                                    placeholder="Escriba el nombre completo"
                                    class="uppercase"
                                    [class.is-invalid]="nombre"
                                    required
                                />
                                <mat-error *ngIf="nombre">Ingrese un nombre</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Apellido</mat-label>
                                <input
                                    matInput
                                    formControlName="apellido"
                                    placeholder="Escriba el apellido completo"
                                    class="uppercase"
                                    [class.is-invalid]="apellido"
                                    required
                                />
                                <mat-error *ngIf="apellido">Ingrese un apellido</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Tipo de identificación</mat-label>
                                <mat-select
                                    formControlName="tipoIdentificacion"
                                    (selectionChange)="onChangeTipoIdentificacion($event.value)"
                                >
                                    <mat-option *ngFor="let ti of tiposIdentificaciones" [value]="ti.concepto">
                                        {{ ti.concepto }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="tipoIdentificacion">Ingrese un tipo de identificación</mat-error>
                            </mat-form-field>

                            <div class="afiliado-grid__full">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Número de identificación - D.N.I</mat-label>
                                    <input
                                        matInput
                                        formControlName="identificacion"
                                        placeholder="Escriba el número de identificación"
                                        [class.is-invalid]="identificacion"
                                    />
                                    <mat-error *ngIf="identificacion">Ingrese una identificación</mat-error>
                                </mat-form-field>

                                <div *ngIf="flagExisteIdentificacion" class="ds-alert ds-alert--danger">
                                    <span class="material-icons">error</span>
                                    <div>
                                        <strong>La identificación ya existe en el sistema.</strong>
                                        Tiene asociada otra cuenta de email. Contacte al administrador para
                                        validar la identidad y continuar.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">cake</span>
                        Nacimiento y contacto
                    </div>
                    <div class="ds-section__body">
                        <div class="afiliado-grid">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Fecha de nacimiento</mat-label>
                                <input matInput formControlName="birth" [matDatepicker]="birthPicker" />
                                <mat-datepicker-toggle matSuffix [for]="birthPicker"></mat-datepicker-toggle>
                                <mat-datepicker #birthPicker></mat-datepicker>
                                <mat-error *ngIf="birth">Ingrese la fecha de nacimiento</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>País de nacimiento</mat-label>
                                <input
                                    matInput
                                    formControlName="paisNacimiento"
                                    (ngModelChange)="onChangePais($event)"
                                    list="paises"
                                    placeholder="Escriba para buscar..."
                                    [class.is-invalid]="paisNacimiento"
                                />
                                <mat-error *ngIf="paisNacimiento">Ingrese un país de nacimiento</mat-error>
                            </mat-form-field>
                            <datalist id="paises">
                                <option *ngFor="let pais of paises" [value]="pais.name_es">
                                    {{ pais.name_es }}
                                </option>
                            </datalist>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Estado civil</mat-label>
                                <mat-select
                                    formControlName="estadoCivil"
                                    (selectionChange)="onChangeEstadoCivil($event.value)"
                                >
                                    <mat-option *ngFor="let estadoCivil of estadosCiviles" [value]="estadoCivil.concepto">
                                        {{ estadoCivil.concepto }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="estadoCivil">Seleccione el estado civil</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Código de área</mat-label>
                                <input
                                    matInput
                                    formControlName="paisCodeArea"
                                    placeholder="Escriba el código de área"
                                    [class.is-invalid]="paisCodeArea"
                                />
                                <mat-error *ngIf="paisCodeArea">Ingrese un código de área</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Número de teléfono</mat-label>
                                <input
                                    matInput
                                    formControlName="telefono"
                                    placeholder="Escriba el número de teléfono"
                                    [class.is-invalid]="telefono"
                                />
                                <mat-error *ngIf="telefono">Ingrese un número de teléfono</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">business</span>
                        Datos institucionales
                    </div>
                    <div class="ds-section__body">
                        <div class="afiliado-grid">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Plan</mat-label>
                                <mat-select formControlName="signoPlan" [disabled]="!planes">
                                    <mat-option *ngFor="let plan of planes" [value]="plan._id">
                                        {{ plan.denominacion }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="plan">Seleccione un plan</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Sede</mat-label>
                                <mat-select formControlName="signoSedes" [disabled]="!sedes" required>
                                    <mat-option *ngFor="let sede of sedes" [value]="sede._id">
                                        {{ sede.nombre }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="sede">Seleccione una sede</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Empresa</mat-label>
                                <mat-select formControlName="signoEmpresas" [disabled]="!empresas">
                                    <mat-option *ngFor="let empresa of empresas" [value]="empresa._id">
                                        {{ empresa.nombre }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="empresa">Seleccione una empresa</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="afiliado-inline-action">
                            <button
                                type="button"
                                class="ds-pill ds-pill--outline"
                                (click)="sincronizarInstitucionalesGecros()"
                                [disabled]="!gecrosData || isLoading"
                                matTooltip="Aplica al afiliado la sede y el plan que devuelve Gecros"
                            >
                                <span class="material-icons">sync</span>
                                Sincronizar con Gecros
                            </button>
                        </div>
                    </div>
                </div>

                <div class="afiliado-actions">
                    <div *ngIf="!formAfiliado.valid" class="ds-alert ds-alert--danger afiliado-actions__alert">
                        <span class="material-icons">error</span>
                        <div>
                            Faltan campos:
                            <span *ngIf="formAfiliado.get('nombre').invalid">Nombre, </span>
                            <span *ngIf="formAfiliado.get('apellido').invalid">Apellido, </span>
                            <span *ngIf="formAfiliado.get('tipoIdentificacion').invalid">Tipo ID, </span>
                            <span *ngIf="formAfiliado.get('identificacion').invalid">ID, </span>
                            <span *ngIf="formAfiliado.get('signoSedes').invalid">Sede, </span>
                            <span *ngIf="formAfiliado.get('signoPlan').invalid">Plan, </span>
                            <span *ngIf="formAfiliado.get('birth').invalid">Fecha Nac., </span>
                        </div>
                    </div>

                    <div class="afiliado-actions__btns">
                        <button
                            type="button"
                            routerLink="/afiliados-listado"
                            class="ds-pill ds-pill--ghost"
                            matTooltip="Volver al listado sin guardar"
                        >
                            <span class="material-icons">close</span>
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            class="ds-pill ds-pill--primary"
                            [disabled]="!formAfiliado.valid"
                            matTooltip="Guardar los cambios del afiliado"
                        >
                            <span class="material-icons">save</span>
                            Guardar
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <!-- ================= Grupo familiar ================= -->
        <div class="afiliado-pane" *ngIf="tabActiva === 'grupo-familiar'">
            <div class="ds-card">
                <div class="ds-section__head">
                    <span class="material-icons">groups</span>
                    Grupo familiar
                    <span class="ds-modal__spacer"></span>
                    <button
                        type="button"
                        class="ds-pill ds-pill--primary ds-pill--sm"
                        (click)="abrirModalNuevoFamiliar()"
                        matTooltip="Vincular un familiar nuevo a este afiliado"
                    >
                        <span class="material-icons">person_add</span>
                        Nuevo familiar
                    </button>
                </div>
                <div class="ds-section__body">
                    <app-loading *ngIf="flagCargandoGrupoFamiliar" class="m-5"></app-loading>

                    <div *ngIf="!flagCargandoGrupoFamiliar">
                        <div class="tabla-wrapper" *ngIf="flagGrupoFamiliar">
                            <table mat-table [dataSource]="dataSource" matSort class="material-table">
                                <ng-container matColumnDef="nombre">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre y apellido</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element?.nombrePersona + ' ' + element?.apellidoPersona }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="identificacion">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Documento</th>
                                    <td mat-cell *matCellDef="let element">{{ element?.identificacion }}</td>
                                </ng-container>

                                <ng-container matColumnDef="domicilio">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Domicilio</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ getDomicilioFamiliar(element) }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="email">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                                    <td mat-cell *matCellDef="let element">{{ element?.email }}</td>
                                </ng-container>

                                <ng-container matColumnDef="sede">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Sede</th>
                                    <td mat-cell *matCellDef="let element">{{ getNombreSede(element) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="plan">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Plan</th>
                                    <td mat-cell *matCellDef="let element">{{ element?.signoPlan }}</td>
                                </ng-container>

                                <ng-container matColumnDef="empresa">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Empresa</th>
                                    <td mat-cell *matCellDef="let element">{{ getNombreEmpresa(element) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="acciones">
                                    <th mat-header-cell *matHeaderCellDef>Acciones</th>
                                    <td mat-cell *matCellDef="let element" class="acciones-cell">
                                        <button
                                            type="button"
                                            class="ds-icon-btn afiliado-icon-danger"
                                            (click)="eliminarFamiliar(element._id)"
                                            matTooltip="Desvincular este familiar del afiliado"
                                            aria-label="Eliminar familiar"
                                        >
                                            <span class="material-icons">delete</span>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                            </table>

                            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                        </div>

                        <div *ngIf="!flagGrupoFamiliar" class="ds-empty">
                            <span class="material-icons">group_off</span>
                            <p>No se encontraron familiares vinculados.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ================= Gestión ================= -->
        <div class="afiliado-pane" *ngIf="tabActiva === 'gestion'">
            <form [formGroup]="formAfiliado" (ngSubmit)="onSubmit()">
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">info</span>
                        Información
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-alert ds-alert--info">
                            <span class="material-icons">info</span>
                            <div>
                                Si el usuario al que se le cambia el <strong>Estado</strong> es titular, el
                                cambio se aplica a sus familiares. En caso de <u>suspensión</u>, si un familiar
                                posee alguna cláusula, quedará excluido.
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Reinscripción O.S. -->
                <div class="ds-card afiliado-reinscripcion">
                    <div class="ds-section__head">
                        <span class="material-icons">restart_alt</span>
                        Reinscripción O.S.
                        <span
                            class="ds-chip ds-chip--aprobado afiliado-reinscripcion__chip"
                            *ngIf="formAfiliado.get('reinscripcionOs').value"
                        >
                            ACTIVA
                        </span>
                    </div>
                    <div class="ds-section__body afiliado-reinscripcion__body">
                        <label
                            class="ds-switch"
                            matTooltip="Habilita que esta persona vuelva a iniciar la inscripción desde la web aunque su cuenta ya exista. Se desactiva al aprobar la solicitud."
                        >
                            <input
                                type="checkbox"
                                [checked]="formAfiliado.get('reinscripcionOs').value === true"
                                (change)="updateValuesReinscripcion($event.target.checked)"
                            />
                            <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                            <span class="ds-switch__label">Permitir reinscripción</span>
                        </label>

                        <p class="afiliado-reinscripcion__hint">
                            Solo para casos puntuales. Si la cuenta ya existe, la persona podrá enviar
                            una nueva solicitud desde la web usando
                            <strong>el mismo email</strong> registrado. Guardá los cambios con el botón
                            <strong>Guardar</strong> para aplicarlo; el permiso se apaga automáticamente
                            al aprobar la solicitud.
                        </p>
                    </div>
                </div>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">event</span>
                        Estado y fechas principales
                    </div>
                    <div class="ds-section__body">
                        <div class="afiliado-grid">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="estado">
                                    <mat-option *ngFor="let estado of estados" [value]="estado">
                                        {{ estado }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="estado">Seleccione un estado</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Fecha de vigencia</mat-label>
                                <input matInput formControlName="fechaVigencia" [matDatepicker]="picker1" />
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                                <mat-error *ngIf="fechaVigenciaNoValida">Ingrese una fecha</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Fecha de cobertura</mat-label>
                                <input matInput formControlName="fechaCobertura" [matDatepicker]="picker2" />
                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Fecha de baja</mat-label>
                                <input matInput formControlName="fechaBaja" [matDatepicker]="picker3" />
                                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                <mat-datepicker #picker3></mat-datepicker>
                                <mat-error *ngIf="fechaNoValida">Ingrese una fecha</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">medical_services</span>
                        Condiciones especiales
                    </div>
                    <div class="ds-section__body">
                        <div class="afiliado-toggles">
                            <label class="ds-switch">
                                <input type="checkbox" formControlName="pmi" />
                                <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                                <span class="ds-switch__label">PMI</span>
                            </label>

                            <label class="ds-switch">
                                <input type="checkbox" formControlName="discapacidad" />
                                <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                                <span class="ds-switch__label">Discapacidad</span>
                            </label>

                            <label class="ds-switch">
                                <input type="checkbox" formControlName="otrasCronicidades" />
                                <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                                <span class="ds-switch__label">Otras cronicidades</span>
                            </label>
                        </div>

                        <mat-form-field appearance="outline" class="full-width afiliado-patologias">
                            <mat-label>Patologías</mat-label>
                            <mat-select formControlName="patologias" multiple>
                                <mat-option *ngFor="let patologia of patologiasDisponibles" [value]="patologia">
                                    {{ patologia }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">event_busy</span>
                        Vencimientos
                    </div>
                    <div class="ds-section__body">
                        <div class="afiliado-grid">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Vencimiento PMI</mat-label>
                                <input matInput formControlName="fechaVtoPMI" [matDatepicker]="picker4" />
                                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                <mat-datepicker #picker4></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Vencimiento discapacidad</mat-label>
                                <input matInput formControlName="fechaVtoDiscapacidad" [matDatepicker]="picker5" />
                                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                <mat-datepicker #picker5></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Vencimiento otras cronicidades</mat-label>
                                <input
                                    matInput
                                    formControlName="fechaVtoOtrasCronicidades"
                                    [matDatepicker]="picker6"
                                />
                                <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                                <mat-datepicker #picker6></mat-datepicker>
                                <mat-error *ngIf="fechaNoValidaCronicidades">Ingrese una fecha</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="afiliado-actions">
                    <div *ngIf="!formAfiliado.valid" class="ds-alert ds-alert--danger afiliado-actions__alert">
                        <span class="material-icons">error</span>
                        <div>
                            Faltan campos:
                            <span *ngIf="formAfiliado.get('nombre').invalid">Nombre, </span>
                            <span *ngIf="formAfiliado.get('apellido').invalid">Apellido, </span>
                            <span *ngIf="formAfiliado.get('tipoIdentificacion').invalid">Tipo ID, </span>
                            <span *ngIf="formAfiliado.get('identificacion').invalid">ID, </span>
                            <span *ngIf="formAfiliado.get('signoSedes').invalid">Sede, </span>
                            <span *ngIf="formAfiliado.get('signoPlan').invalid">Plan, </span>
                            <span *ngIf="formAfiliado.get('birth').invalid">Fecha Nac., </span>
                        </div>
                    </div>

                    <div class="afiliado-actions__btns">
                        <button
                            type="button"
                            routerLink="/afiliados-listado"
                            class="ds-pill ds-pill--ghost"
                            matTooltip="Volver al listado sin guardar"
                        >
                            <span class="material-icons">close</span>
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            class="ds-pill ds-pill--primary"
                            [disabled]="!formAfiliado.valid"
                            matTooltip="Guardar los cambios del afiliado"
                        >
                            <span class="material-icons">save</span>
                            Guardar
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <!-- ================= Trámites ================= -->
        <div class="afiliado-pane" *ngIf="tabActiva === 'tramites'">
            <div class="ds-card">
                <div class="ds-section__head">
                    <span class="material-icons">description</span>
                    Solicitudes generadas
                </div>
                <div class="ds-section__body">
                    <app-loading *ngIf="!solicitudesDataSource?.data"></app-loading>

                    <ng-container *ngIf="solicitudesDataSource?.data.length > 0; else noSolicitudes">
                        <div class="tabla-wrapper">
                            <table mat-table [dataSource]="solicitudesDataSource">
                                <ng-container matColumnDef="nro solicitud">
                                    <th mat-header-cell *matHeaderCellDef>N° solicitud</th>
                                    <td mat-cell *matCellDef="let s">{{ s._nro || 'N/A' }}</td>
                                </ng-container>

                                <ng-container matColumnDef="fecha">
                                    <th mat-header-cell *matHeaderCellDef>Fecha</th>
                                    <td mat-cell *matCellDef="let s">{{ s.createdAt | date: 'dd/MM/yyyy' }}</td>
                                </ng-container>

                                <ng-container matColumnDef="estado">
                                    <th mat-header-cell *matHeaderCellDef>Estado</th>
                                    <td mat-cell *matCellDef="let s">
                                        {{ s.lastState?.state || 'Sin estado asignado' }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="acciones">
                                    <th mat-header-cell *matHeaderCellDef>Acciones</th>
                                    <td mat-cell *matCellDef="let solicitud" class="acciones-cell">
                                        <button
                                            type="button"
                                            class="ds-icon-btn"
                                            (click)="verSolicitud(solicitud)"
                                            matTooltip="Abrir el detalle de la solicitud"
                                            aria-label="Ver solicitud"
                                        >
                                            <span class="material-icons">visibility</span>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsSolicitudes"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsSolicitudes"></tr>
                            </table>

                            <mat-paginator
                                #soliPaginator
                                [pageSizeOptions]="[5, 10, 25]"
                                showFirstLastButtons
                                aria-label="Selector de páginas"
                            ></mat-paginator>
                        </div>
                    </ng-container>

                    <ng-template #noSolicitudes>
                        <div class="ds-empty">
                            <span class="material-icons">inbox</span>
                            <p>No se encontraron solicitudes generadas para esta persona.</p>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="loading" class="loading-overlay">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
</div>

<app-spinner
    [show]="isLoading"
    [text]="'Cargando datos del afiliado'"
    [type]="'fullscreen'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [blurBackground]="true"
>
</app-spinner>
